import { avatarColors } from "contains/contants";
import React, { FC } from "react";
import avatar1 from "../../assets/img/avatar.png";

export interface AvatarProps {
	containerClassName?: string;
	sizeClass?: string;
	radius?: string;
	imgUrl?: string;
	userName?: string;
	hasChecked?: boolean;
	hasCheckedClass?: string;
}

const Avatar: FC<AvatarProps> = ({
	containerClassName = "ring-1 ring-white",
	sizeClass = "h-6 w-6 text-sm",
	radius = "rounded-full",
	imgUrl = avatar1,
	userName,
	hasChecked,
	hasCheckedClass = "w-4 h-4 -top-0.5 -right-0.5",
}) => {
	const url = imgUrl || "/avatar.png";
	const name = userName || "User";
	const _setBgColor = (name: string) => {
		const backgroundIndex = Math.floor(
			name.charCodeAt(0) % avatarColors.length
		);
		return avatarColors[backgroundIndex];
	};

	return (
		<div
			className={`wil-avatar relative flex-shrink-0 inline-flex items-center justify-center text-neutral-100 uppercase font-semibold shadow-inner ${radius} ${sizeClass} ${containerClassName}`}
			style={{ backgroundColor: url ? undefined : _setBgColor(name) }}
		>
			{url && (
				<img
					className={`absolute inset-0 w-full h-full object-cover ${radius}`}
					src={url}
					alt={name}
				/>
			)}
			{hasChecked && (
				<span
					className={` bg-sky-500 rounded-full text-white text-xs flex items-center justify-center absolute  ${hasCheckedClass}`}
				>
					<i className="fas fa-check"></i>
				</span>
			)}
		</div>
	);
};

export default Avatar;
